import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import ArtistsPage from "../pages/artists/page";
import WorkPage from "../pages/work/page";
import WorkDetailPage from "../pages/work/detail/page";
import VisitPage from "../pages/visit/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/artists", element: <ArtistsPage /> },
  { path: "/work", element: <WorkPage /> },
  { path: "/work/:slug", element: <WorkDetailPage /> },
  { path: "/visit", element: <VisitPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;